import { render, staticRenderFns } from "./product_info.vue?vue&type=template&id=94e33648&scoped=true"
import script from "./product_info.vue?vue&type=script&lang=js"
export * from "./product_info.vue?vue&type=script&lang=js"
import style0 from "./product_info.vue?vue&type=style&index=0&id=94e33648&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e33648",
  null
  
)

export default component.exports